import genericNotifications, {
  notificationAction,
  notificationTitles,
} from '../../utils/genericNotifications';

const authNotifications = {
  updateUserDetails: (name: string) =>
    genericNotifications(
      notificationTitles.userDetails,
      name,
      notificationAction.update,
    ),
};

export { authNotifications };
